export const UTM_SOURCE_KEY = 'utm_source';
export const UTM_MEDIUM_KEY = 'utm_medium';
export const UTM_CAMPAIGN_KEY = 'utm_campaign';
export const UTM_ID_KEY = 'utm_id';
export const UTM_CONTENT_KEY = 'utm_content';

export const HICAPS_BILLER_ID_KEY = 'hicaps_biller_id';
